import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/data";
import { Reveal, Eyebrow } from "./Reveal";

export default function Services({ onQuote }) {
  return (
    <section id="services" className="relative py-28 lg:py-40 bg-ink" data-testid="services">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-20">
          <div>
            <Reveal><Eyebrow>What We Move</Eyebrow></Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-6 font-serif font-light text-cream text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
                Four disciplines.<br />
                <span className="italic text-gold">One standard of care.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-cream/60 font-light leading-relaxed">
              Every route we run — whether freight or a fragile passenger — is handled with the
              precision a Fortune-100 fleet demands and the heart a community deserves.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-gold/10 border border-gold/10">
          {SERVICES.map((s, i) => (
            <motion.button
              key={s.id}
              onClick={onQuote}
              data-testid={`service-${s.id}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="group relative text-left bg-ink hover:bg-ink-2 transition-colors duration-500 p-10 lg:p-14"
            >
              <div className="flex items-start justify-between">
                <span className="font-serif italic text-5xl text-gold/25 group-hover:text-gold/60 transition-colors">
                  {s.n}
                </span>
                <ArrowUpRight
                  size={26}
                  className="text-cream/30 group-hover:text-gold group-hover:rotate-0 -rotate-45 transition-all duration-500"
                />
              </div>
              <h3 className="mt-8 font-serif text-2xl lg:text-3xl text-cream font-light">{s.title}</h3>
              <p className="mt-4 text-cream/55 font-light leading-relaxed max-w-md">{s.desc}</p>
              <div className="mt-7 flex flex-wrap gap-2">
                {s.tags.map((t) => (
                  <span
                    key={t}
                    className="text-[11px] tracking-widest uppercase text-gold/70 border border-gold/25 px-3 py-1"
                  >
                    {t}
                  </span>
                ))}
              </div>
            </motion.button>
          ))}
        </div>
      </div>
    </section>
  );
}
